import styled from 'styled-components';

const StyledBurger = styled.button`
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  width: 2rem;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  outline: none;
  span {
    width: 2rem;
    height: 0.25rem;
    background: ${({ color, theme }) => theme[color] || color};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    :first-child {      
      opacity: ${({ open }) => (open ? '0' : '1')};
    }
    :nth-child(2) {
      transform: ${({ open }) => (open ? 'rotate(45deg)' : 'rotate(0)')};
    }
    :nth-child(3) {
      transform: ${({ open }) => (open ? 'translateY(-8px) rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

export default StyledBurger;
